export const constructionPages = [
  { path: '/receiving', label: 'รับสินค้าเข้า', icon: 'receive' },
  { path: '/labels', label: 'ฉลากยา', icon: 'labels' },
  {
    path: '/sales-history',
    label: 'ประวัติการขาย',
    icon: 'sales-history',
  },
  { path: '/branches', label: 'จัดการสาขา', icon: 'branches' },
  {
    path: '/transfers',
    label: 'ขนย้ายระหว่างสาขา',
    icon: 'transfer',
  },
  { path: '/members', label: 'ระบบสมาชิก', icon: 'members' },
] as const
